import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Box,
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Text,
  useToast,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_vehicle_list } from "../../redux/vehiclSlice";
import CustomButton from "../../components/CustomButton";
import GasCylinderLoader from "../../components/GasCylinderLoader";
import ToggleSwitch from "../../components/ToggleSwitch";
import { baseUrl } from "../../utils/utils";
import { ArrowRight } from "lucide-react";

const VehicleList = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const [rows, setRows] = useState(location.state?.rows || 10);
  const [page, setpage] = useState(location.state?.page || 1);
  const [initialValue, setInitialValue] = useState(
    location.state?.page
      ? (location.state.page - 1) * (location.state.rows || 5) + 1
      : 1,
  );

  const [searchTerm, setSearchTerm] = useState(""); // ✅ Added search state
  const {
    dp_list,
    total_dp_count,
    loading: dp_loading,
  } = useSelector((state) => state.dplist);
  const {
    driver_list,
    total_driver_count,
    loading: dr_loading,
  } = useSelector((state) => state.drivers);
  const { vehicle_list, total_vehicle_count, loading } = useSelector(
    (state) => state.vehicles,
  );
  console.log("dp_list", dp_list);
  console.log("driver_list", driver_list);

  useEffect(() => {
    store.dispatch(get_vehicle_list({ page: page, rows: rows }));
  }, [page, rows]);

  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_vehicle_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_vehicle_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_vehicle_count || setpage(page + 1);
    rows * page >= total_vehicle_count ||
      store.dispatch(get_vehicle_list({ page: page + 1, rows: rows }));
  };

  // ✅ Filter vehicles based on vehicleno, type, make, or capacity
  const filteredVehicles = vehicle_list.filter((vehicle) => {
    const search = searchTerm.toLowerCase();
    return (
      vehicle.vehicleno?.toLowerCase().includes(search) ||
      vehicle.type?.toLowerCase().includes(search) ||
      vehicle.make?.toLowerCase().includes(search) ||
      vehicle.capacity?.toString().toLowerCase().includes(search)
    );
  });

  const handleAutoAssign = async (id, status) => {
    try {
      const body = new FormData();
      body.append("action", "update_status");
      body.append("id", id);
      body.append("status", status);

      const response = await fetch(`${baseUrl}vehicle.php`, {
        method: "POST",
        body: body,
      });

      const data = await response.json();

      if (data.success) {
        store.dispatch(get_vehicle_list({ page: page, rows: rows }));
        toast({
          title: "Success",
          description: data.message,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        console.log("Failed:", data.message);
        toast({
          title: "Error",
          description: data.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error in auto assign:", error);
    }
  };

  return (
    <>
      <Card
        display="flex"
        flexDirection="column"
        paddingInline={5}
        paddingBlock={2}
        gap={3}
        w="100%"
        mb={4}
      >
        <Flex
          justify="space-between"
          align="center"
          flexWrap="wrap"
          direction={["column", "row"]}
          w="100%"
          gap={4}
        >
          {/* Left: Heading */}
          <Heading fontSize="xl">Vehicle List</Heading>

          {/* Right: Select, Input, Button */}
          <Flex
            align="center"
            gap={3}
            flexWrap="wrap"
            direction={["column", "row"]}
            w={["100%", "auto"]}
          >
            <Select
              placeholder=""
              size="md"
              value={rows}
              onChange={(e) => {
                store.dispatch(
                  get_vehicle_list({ page: page, rows: e.target.value }),
                );
                setRows(e.target.value);
              }}
              w={["100%", "80px"]}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>

            {/* ✅ Search Input */}
            <InputGroup
              bg="#f4f5f7"
              borderRadius={5}
              maxW="sm"
              w={["100%", "auto"]}
            >
              <Input
                placeholder="Search by vehicle no, type, make, or capacity..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <InputRightElement>
                <FiSearch />
              </InputRightElement>
            </InputGroup>

            <CustomButton
              title="Add Vehicle"
              paddingInline={5}
              paddingBlock={4}
              onClick={() =>
                navigate("/vehicle-list/add-vehicle", {
                  state: {
                    page,
                    rows,
                  },
                })
              }
              w={["100%", "auto"]}
            />
          </Flex>
        </Flex>
      </Card>

      {loading ? (
        <GasCylinderLoader size="sm" loadingText="Loading Dp List" />
      ) : (
        <>
          {/* ✅ Filtered Vehicle List */}
          <SimpleGrid minChildWidth="xs" spacing="10px">
            {filteredVehicles.length > 0 ? (
              filteredVehicles.map((el, i) => (
                <Card
                  key={i}
                  paddingInline={5}
                  paddingBlock={2}
                  cursor="pointer"
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                  _hover={{ boxShadow: "md", transform: "translateY(-3px)" }}
                  transition="all 0.2s ease"
                  // onClick={() =>
                  //   navigate("/vehicle-list/vehicle-detail", {
                  //     state: {
                  //       id: el.id,
                  //       page,
                  //       rows,
                  //     },
                  //   })
                  // }
                >
                  {/* Header: Vehicle No & Type */}
                  <Flex justify="space-between" mb={2}>
                    <DisplayData
                      fs="16px"
                      v_color="#007bc9"
                      fw="bold"
                      value={el.vehicleno || "NA"}
                    />
                    <DisplayData
                      v_color="#f37022"
                      fw="bold"
                      value={el.type || "NA"}
                    />
                  </Flex>

                  {/* Details Section */}
                  <Box mt={1}>
                    {[
                      { title: "Make", value: el.make },
                      { title: "Chassis No.", value: el.chassis },
                      { title: "Capacity", value: el.capacity },
                    ].map((item, idx) => (
                      <Flex
                        key={idx}
                        justify="space-between"
                        align="center"
                        mb="1"
                        wrap="nowrap"
                      >
                        <Text
                          fontSize="sm"
                          color="gray.600"
                          flex="1"
                          noOfLines={1}
                        >
                          {item.title}
                        </Text>
                        <Text
                          fontSize="sm"
                          color={item.v_color || "gray.800"}
                          flex="1"
                          textAlign="right"
                          noOfLines={1}
                        >
                          {item.value || "NA"}
                        </Text>
                      </Flex>
                    ))}
                  </Box>
                  <Flex
                    justify="space-between"
                    align="center"
                    mb="1"
                    wrap="nowrap"
                  >
                    <Text fontSize="sm" color="gray.600" flex="1" noOfLines={1}>
                      Status
                    </Text>
                    <ToggleSwitch
                      leftLable={"Inactive"}
                      rightLable={"Active"}
                      isOn={el?.status == "2"}
                      handleToggle={() =>
                        handleAutoAssign(el.id, el?.status == "2" ? "1" : "2")
                      }
                    />
                  </Flex>
                  <Flex justify={"flex-end"} mt={3}>
                    <CustomButton
                      title={"View"}
                      rightIcon={<ArrowRight />}
                      onClick={() =>
                        navigate("/vehicle-list/vehicle-detail", {
                          state: {
                            id: el.id,
                            page,
                            rows,
                          },
                        })
                      }
                    />
                  </Flex>
                </Card>
              ))
            ) : (
              <Text textAlign="center" color="gray.500">
                No vehicles found.
              </Text>
            )}
          </SimpleGrid>

          {/* Pagination */}
          <Card
            alignItems={"center"}
            alignSelf={"end"}
            gap={3}
            flexDirection={"row"}
          >
            <FiChevronLeft
              cursor={"pointer"}
              color={page == 1 ? "gray" : "#007bc9"}
              size={35}
              onClick={onPrevious}
            />
            <Flex gap={3}>
              <Text>{initialValue}</Text>-
              <Text>
                {rows * page >= total_vehicle_count
                  ? total_vehicle_count
                  : rows * page}
              </Text>
              <Text>of</Text>
              <Text>{total_vehicle_count}</Text>
            </Flex>
            <FiChevronRight
              cursor={"pointer"}
              color={rows * page >= total_vehicle_count ? "gray" : "#007bc9"}
              size={35}
              onClick={onNext}
            />
          </Card>
        </>
      )}
    </>
  );
};

export default VehicleList;
